import { Stack, Typography } from '@mui/material';
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  state: string;
  onChange: (state: string) => void;
}

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : '#00D03A',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : '#CB333B',
    boxSizing: 'border-box',
  },
}));

export default function StateSwitch({ state, onChange }: Props) {
  const { t: i18T } = useTranslation();

  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 1 }}>
      <Typography sx={{ color: '#CB333B', fontWeight: 600 }}>
        {i18T('USERSMANAGEMENU.THIRD_PARTY_ACCOUNT_MANAGEMENT.DISABLED')}
      </Typography>
      <AntSwitch
        inputProps={{ 'aria-label': 'third party account state' }}
        checked={state === '1'}
        onChange={() => onChange(state === '1' ? '0' : '1')}
      />
      <Typography sx={{ color: '#00D03A', fontWeight: 600 }}>
        {i18T('USERSMANAGEMENU.THIRD_PARTY_ACCOUNT_MANAGEMENT.ENABLE')}
      </Typography>
    </Stack>
  );
}
